import React from 'react';
import { connect } from 'react-redux';
import { MdInfoOutline } from 'react-icons/md';
import { fobiCore } from '../FobiCore';
import { getIntendedVNR } from '../prestartPreparation';

/**
 * Sagt im Hinzufuegen-Formular, warum jetzt ein Kennwort verlangt wird.
 *
 * Wer aus dem Portal der Kammer mit `?vnr=...` kommt und dessen Veranstaltung nicht geladen ist,
 * landet hier - und stand bisher vor einem leeren Kennwortfeld ohne jeden Bezug zu dem Link, dem
 * er gefolgt ist. Der haeufigste Grund ist die ausgeschaltete Speicherung; deshalb steht er im
 * Text, statt dass sich der Anwender wundert, warum das jeden Tag wieder passiert.
 *
 * **Kein Store-Feld fuer "kam ueber einen Link".** Die URL ist die Quelle und bleibt stehen; das
 * spart eine Action, ein Feld und eine Ausnahme in `saveState`. Es korrigiert sich ausserdem von
 * selbst: tippt jemand eine andere VNR ins Feld, passt sie nicht mehr zur Link-VNR und der
 * Hinweis verschwindet.
 *
 * Kein reactstrap-`Alert`: dessen `role="alert"` laesst sich nicht ueberschreiben und unterbricht
 * den Screenreader mitten im Satz.
 */
export const portalVnrHinweis = (linkVnr, vnrImFeld, gespeichert) => {
	if(!linkVnr || !fobiCore.isVNR(linkVnr) || linkVnr !== vnrImFeld) return null;
	if(gespeichert) return {
		kopf: "Diese Veranstaltung ist auf diesem Gerät noch nicht hinterlegt.",
		satz: `Bitte das Kennwort zur VNR ${linkVnr} eingeben. Danach bleibt sie auf diesem Gerät gespeichert.` };
	return {
		kopf: "Diese Veranstaltung ist auf diesem Gerät nicht hinterlegt.",
		satz: `Bitte das Kennwort zur VNR ${linkVnr} eingeben. Auf diesem Gerät wird nichts `
			+ `gespeichert – nach jedem Neuladen ist sie erneut hinzuzufügen.` };
};

const PortalVnrHinweis = (props) => {
	const { vnrImFeld, gespeichert } = props;
	const hinweis = portalVnrHinweis(getIntendedVNR(), vnrImFeld, gespeichert);
	if(hinweis === null) return null;
	return (
		<div className="alert alert-info py-2 mb-2 d-flex align-items-start gap-2"
			role="status" aria-live="polite">
			<MdInfoOutline fontSize="1.3em" className="flex-shrink-0 mt-1" aria-hidden="true" />
			<div><b>{hinweis.kopf}</b> {hinweis.satz}</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	vnrImFeld: state.addVeranstaltungPanel.vnr,
	gespeichert: Boolean(state.appNavigation.saveStateToLocalStorage)
});

export default connect(mapStateToProps)(PortalVnrHinweis);
